import React from 'react'
import { useGetXRateLimits, useMe } from 'src/hooks'
import { Loader } from '../loader'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from '@mui/material'
import { IRateLimitInfoExtended } from 'src/types'
import { UtcAndLocalDatesCell } from '../utc-and-local-dates-cell'

export const XRateLimitsComponent: React.FC = () => {
  const { data } = useGetXRateLimits()
  const { data: user } = useMe()

  if (!data) {
    return <Loader />
  }

  // split out default and TrackFi entries
  const defaultEntries = Object.entries(data.default) as [string, IRateLimitInfoExtended][]
  const trackfiEntries = Object.entries(data.trackfi) as [string, IRateLimitInfoExtended][]

  const renderTable = (title: string, entries: [string, IRateLimitInfoExtended][]) => (
    <>
      <Typography fontSize={'14px'} fontWeight={700} gutterBottom>
        {title}
      </Typography>
      <TableContainer component={Box} sx={{ maxHeight: 400, mb: 4 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Endpoint</TableCell>
              <TableCell align="center">Method</TableCell>
              <TableCell>Desc</TableCell>
              <TableCell align="center">Limit</TableCell>
              <TableCell align="center">Remaining</TableCell>
              <TableCell align="center">Resets At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map(([endpoint, info]) => (
              <TableRow key={endpoint} hover>
                <TableCell sx={{ wordBreak: 'break-all' }}>{endpoint}</TableCell>
                <TableCell align="center">{info.method.toUpperCase()}</TableCell>
                <TableCell>{info.description}</TableCell>
                <TableCell align="center">
                  {info.limit}
                  {info.day && (
                    <Typography variant="caption" display="block">
                      Per day: {info.day.limit}
                    </Typography>
                  )}
                </TableCell>
                <TableCell align="center">
                  {info.remaining}
                  {info.day && (
                    <Typography variant="caption" display="block">
                      Per day: {info.day.remaining}
                    </Typography>
                  )}
                </TableCell>
                <TableCell sx={{ fontSize: '11px' }} align="center">
                  <UtcAndLocalDatesCell
                    date={new Date(info.reset * 1000)}
                    loalTimezone={user?.timezone}
                  />
                  {info.day && (
                    <Typography variant="caption" display="block">
                      Day reset:
                      <UtcAndLocalDatesCell
                        date={new Date(info.day.reset * 1000)}
                        loalTimezone={user?.timezone}
                      />
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )

  return (
    <>
      {renderTable('Traicy', defaultEntries)}
      {renderTable('TrackFi', trackfiEntries)}
    </>
  )
}
